import { geoJsonFilePath, dataFilePath } from '../config';

const dataURLs = {
  data: `${process.env.PUBLIC_URL}/${dataFilePath}`,
  geo: `${process.env.PUBLIC_URL}/${geoJsonFilePath}`,
};

// export const getCouncilData = () =>
//   fetch(dataURLs.hhs).then(response => response.json());

export const getWaterData = () =>
  fetch(dataURLs.data).then(response => response.json());

export const getQldRegionGeo = () =>
  fetch(dataURLs.geo).then(response => response.json());



// WEBPACK FOOTER //
// ./src/api/index.js